import ApplicationService from "../services/ApplicationService";

export default function useApplication() {
	return ApplicationService.getInstance();
}